// idNumber format is FD-XXXX-YY, where YY is the 2-digit year (e.g. 25 for 2025).
// Replaces the trailing YY with a new 2-digit year, keeping the rest unchanged.
export function bumpIdNumberYear(idNumber: string, year: string): string {
  const match = idNumber?.match(/^(.*-)(\d{2})$/)
  return match ? `${match[1]}${year}` : idNumber
}
